(function () {
  'use strict';

  function init(section) {
    if (section.dataset.categoryReady === 'true') return;
    section.dataset.categoryReady = 'true';
    initEditorialMedia(section);
    var track = section.querySelector('[data-category-track]');
    var prev = section.querySelector('[data-category-prev]');
    var next = section.querySelector('[data-category-next]');
    if (!track || !prev || !next) return;

    function move(direction) {
      track.scrollBy({ left: direction * track.clientWidth, behavior: 'smooth' });
    }

    prev.addEventListener('click', function () { move(-1); });
    next.addEventListener('click', function () { move(1); });
  }

  function initEditorialMedia(section) {
    var videos = section.querySelectorAll('[data-collection-story] video');
    if (!videos.length) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    videos.forEach(function (video) {
      if (reduceMotion) {
        video.removeAttribute('autoplay');
        video.pause();
      }
    });

    if (reduceMotion || !('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (!video.hasAttribute('autoplay')) return;
        if (entry.isIntersecting) video.play().catch(function () {});
        else video.pause();
      });
    }, { rootMargin: '160px 0px', threshold: 0.15 });

    videos.forEach(function (video) { observer.observe(video); });
  }

  function boot(root) {
    (root || document).querySelectorAll('[data-sidiz-category]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();
